<template>
    <div class="render-short-youtube" :style="{ fontSize: fontSize + 'px' }" ref="render-post">
        <div class="header-app">
            Shorts
        </div>
        <div class="reel-content" @click="clickOnPost">
            <video 
                v-if="medias.length" 
                v-for="media in medias.filter(m => m.type.startsWith('video/')).slice(0,1)" 
                :autoplay="true"
                :muted="videoMuted"
                loop
                playsinline
                crossorigin="anonymous"
                preload="metadata"
                :src="media.url"
                :type="media.type" 
                :key="media.id">
            </video>

            <div class="nav-lateral">
                <div class="like">
                    <svg height="24" viewBox="0 0 24 24" width="auto" fill="#FFF" aria-hidden="true"><path d="M8 21V9.282c0-.834.26-1.647.745-2.325L13 1l.551.331c1.153.691 1.705 2.065 1.351 3.362L14 8h5.192c.827 0 1.609.376 2.125 1.022.711.888.795 2.125.209 3.101L21 13l.165.413c.519 1.296.324 2.769-.514 3.885l-.151.202v.5c0 1.657-1.343 3-3 3H8ZM4.5 9C3.672 9 3 9.672 3 10.5v9c0 .828.672 1.5 1.5 1.5H7V9H4.5Z"></path></svg>
                    <p>J'aime</p>
                </div>
                <div class="dislike">
                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" fill="#FFF" viewBox="0 0 24 24" width="auto" aria-hidden="true"><path d="M16 3v11.718c0 .834-.26 1.647-.745 2.325L11 23l-.551-.331c-1.153-.691-1.705-2.065-1.351-3.362L10 16H4.808c-.827 0-1.609-.376-2.125-1.022-.711-.888-.795-2.125-.209-3.101L3 11l-.165-.413c-.519-1.296-.324-2.769.514-3.885L3.5 6.5V6c0-1.657 1.343-3 3-3H16Zm3 12c1.105 0 2-.895 2-2V5c0-1.105-.895-2-2-2h-2v12h2Z"></path></svg>
                    <p>Je n...pas</p>
                </div>
                <div class="comment">
                    <svg height="auto" viewBox="0 0 24 24" width="auto" fill="#FFF" aria-hidden="true"><path clip-rule="evenodd" d="M21 5c0-1.105-.895-2-2-2H5c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h12l3.146 3.146c.315.315.854.092.854-.353V5ZM7 9c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1Zm1 3c-.552 0-1 .448-1 1s.448 1 1 1h5c.552 0 1-.448 1-1s-.448-1-1-1H8Z" fill-rule="evenodd"></path></svg>
                    <p>0</p>
                </div>
                <div class="send">
                    <svg height="auto" viewBox="0 0 24 24" width="auto" fill="#FFF" aria-hidden="true"><path d="m13.202 3.368 9.438 7.865c.48.4.48 1.137 0 1.537l-9.438 7.865c-.652.543-1.64.08-1.64-.768V16H9.957c-2.778 0-5.406 1.263-7.141 3.432-.304.38-.912.086-.803-.388l1.118-4.843C3.968 10.572 7.2 8 10.926 8h.636V4.137c0-.848.989-1.311 1.64-.769Z"></path></svg>
                    <p>Partager</p>
                </div>

                <div class="square" v-if="pages.length">
                    <img :src="pages[0].avatar">
                </div>
            </div>
            <div class="info-reel">
                <div class="page">
                    <div class="images" :class="{multiple : pages.length > 1}">
                        <img v-for="(page, index) in visiblePages" @click="() => onClickAvatar(page, index)" :src="page.avatar" :key="index">
                        <ContextMenu
                            v-if="pages.length > 3"
                            :options="hiddenPagesOptions"
                            id="contextMenuHiddenPagesShortYoutube"
                            v-on:clickOption="(_, pageId) => $emit('featurePage', pageId)"
                        >
                            <div class="count">
                                +{{ pages.length - 3 }}
                            </div>
                        </ContextMenu>
                    </div>
                    <div class="names">
                        <p class="page-name" v-if="featuredPage" @click="openYoutubePage(featuredPage)">{{ featuredPage.name }}</p>
                    </div>
                </div>
                <!-- <p class="music-name" v-if="musicName && pages.length > 1"><i class="fa-solid fa-music"></i>{{ musicName }}</p> -->
                <div class="description-reel" v-if="textTranslate" :class="{'cut-content': !fullContent}" @click.stop="toggleFullContent" v-html="textTranslate">
                </div>
            </div>
            <div :key="videoMuted ? 'no-sound' : 'sound'" :class="videoMuted ? 'no-sound' : 'sound'"></div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            ContextMenu
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[] 
            },
  
            musicName : {
                type: String,
                default: ''
            },

            description : {
                type: String,
                default: ''
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },
            mentions : {
                type: Object,
                default: ()=>({})
            },
            

        },

        data() {
            return {
                videoMuted: true,
                fullContent: false
            }
        },

        methods: {
            openYoutubePage(page) {
                const url = `https://youtube.com/${page.name}/`;
                window.open(url, '_blank');
            },

            onClickAvatar(page, index) {
                const isTop = index === this.visiblePages.length - 1
                if (!isTop) {
                    this.$emit('featurePage', page.id)
                    return
                }
                page.iconEdited ? this.$emit('clickPage', page.id) : this.openYoutubePage(page)
            },

            clickOnPost(e) {
                this.videoMuted = !this.videoMuted;
            },

            toggleFullContent() {
                this.fullContent = !this.fullContent;
            }
        },

        computed: {
            visiblePages() {
                return this.pages.slice(0, 3)
            },

            featuredPage() {
                return this.visiblePages.length ? this.visiblePages[this.visiblePages.length - 1] : null
            },

            hiddenPagesOptions() {
                return this.pages.slice(this.visiblePages.length).map(page => ({ label: page.name, name: page.id }))
            },


            textTranslate() {
                //return this.text
                return this.description.substring(0,2200).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
                
            },
        },
    }
</script>
